import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_OFFERS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/offers',
        iconClass: 'fas fa-file-alt',
        name: 'Offers',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Offers',
        order: 7
      },
    ]);
  };
}
